'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
require('../node_modules/prop-types/index.js');
var ButtonBase = require('@material-ui/core/ButtonBase');
var Typography = require('@material-ui/core/Typography');
var AscendingIcon = require('@material-ui/icons/ArrowDropUpRounded');
var DescendingIcon = require('@material-ui/icons/ArrowDropDownRounded');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var AscendingIcon__default = /*#__PURE__*/_interopDefaultLegacy(AscendingIcon);
var DescendingIcon__default = /*#__PURE__*/_interopDefaultLegacy(DescendingIcon);

var _excluded = ["onClick", "value", "sortingKey", "direction", "children"];
function SortableHeader(_ref) {
  var {
    onClick,
    value,
    sortingKey,
    direction = 'asc',
    children
  } = _ref,
      buttonProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var handleClick = React__namespace.useCallback(event => {
    var newDirection = value !== sortingKey ? 'asc' : direction === 'asc' ? 'desc' : 'asc';
    onClick(event, sortingKey, newDirection);
  }, [value, direction, sortingKey]);
  var icon = React__namespace.useMemo(() => sortingKey !== value ? null : direction === 'asc' ? /*#__PURE__*/React__namespace.createElement(AscendingIcon__default['default'], {
    color: "primary",
    sx: {
      fontSize: 24
    }
  }) : /*#__PURE__*/React__namespace.createElement(DescendingIcon__default['default'], {
    color: "primary",
    sx: {
      fontSize: 24
    }
  }), [sortingKey, value, direction]);
  return /*#__PURE__*/React__namespace.createElement(ButtonBase__default['default'], _rollupPluginBabelHelpers['extends']({}, buttonProps, {
    onClick: handleClick,
    color: sortingKey === value ? 'secondary' : 'primary',
    disableRipple: true,
    disableTouchRipple: true,
    sx: {
      py: 0.5,
      display: 'flex',
      alignItems: 'center',
      borderRadius: 999
    }
  }), /*#__PURE__*/React__namespace.createElement(Typography__default['default'], {
    color: sortingKey === value ? 'primary' : 'textSecondary',
    variant: "body2",
    sx: {
      // fontVariant: 'small-caps',
      fontWeight: 700,
      mr: sortingKey === value ? 0.5 : 0
    }
  }, children), icon);
}
SortableHeader.propTypes = {};

exports.SortableHeader = SortableHeader;
